/* eslint-disable */
import React, { Suspense } from "react";

import ScreenLoading from "../screenLoading";

export default function ScreenLoadingSuspense(props) {
  return <Suspense {...props} fallback={<ScreenLoading />} />;
}
/* eslint-disable */
